// extracted by mini-css-extract-plugin
export var text = "SectionHead-module--text--630ae";
export var title = "SectionHead-module--title--ca699";